import { useState, useEffect } from "react";

import InputSearch from "/src/components/UI/InputSearch/InputSearch";

import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import ModalManager from "@ebay/nice-modal-react";

import IntegrationCodeLine from "../IntegrationCodeLine/IntegrationCodeLine";

import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import "/src/components/UI/Button/IconButton/IconButton.css";
import integrationService from "../../services/integrationService";
import { useNavigate } from "react-router-dom";
import "./IntegrationTable.css";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import hasPermission from "/src/utils/hasPermission";
import generateKey from "/src/utils/generateKey";

function IntegrationTableMcp() {
    const [integrations, setIntegrations] = useState([]);
    const [search, setSearch] = useState("");
    const [fetching, setFetching] = useState(false);
    const [param, setParam] = useState({ page: 1, filter: {} });
    const navigate = useNavigate();
    var integrationsListTotal = [];
    const { getIntegrationsMcp, deleteIntegration } = integrationService;

    const getIntegrationsList = async () => {
        const { page } = param;
        setFetching(true);
        let [response, error] = await getIntegrationsMcp({ page, term: search });
        if (error !== null) {
            console.log(error);
            return;
        }
        integrationsListTotal = integrations;
        for (let i = 0; i < response.data.length; i++) {
            let newIntegration = response.data[i];
            if (!integrations.some((integ) => integ.id === newIntegration.id)) {
                integrationsListTotal = [...integrationsListTotal, newIntegration];
            }
        }
        setIntegrations(integrationsListTotal);
        setFetching(false);

        return response.data;
    };

    const onClickAdd = () => navigate(urlWithRoutingCompany("/plugin/integrations/create"));

    const onClickDelete = async (integration) => {
        await ModalManager.show(ApiModal, {
            title: "Delete Integration " + integration.name,
            body: "Do you really want to delete Integration " + integration.name,
            api: {
                request: deleteIntegration,
                param: [integration.id],
            },
            buttons: [
                { className: "validate", label: "Cancel" },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
        });
        setIntegrations((current) => current.filter((obj) => obj.id !== integration.id));
    };

    const onScroll = (e) => {
        const { scrollHeight, scrollTop, clientHeight } = e.target;
        if (scrollHeight - scrollTop - clientHeight > 40) return null;
        addPage();
    };

    useEffect(() => {
        document.getElementsByClassName("page")[0].addEventListener("scroll", onScroll);
        return () => {
            var page = document.getElementsByClassName("page")[0];
            if (page) page.removeEventListener("scroll", onScroll);
        };
    }, [fetching]);

    const research = async (_search) => {
        integrationsListTotal = [];
        setSearch(_search);
        setParam({ page: 1, filters: {} });
        let [response, error] = await getIntegrationsMcp({ page: 1, term: _search });
        if (error !== null) {
            console.log(error);
            return;
        }
        setIntegrations(response.data);
    };

    useEffect(() => {
        getIntegrationsList();
    }, [param.page]);

    const addPage = () => {
        if (fetching) return;
        setParam({ page: param.page + 1, filter: param.filter });
    };

    return (
        <div onScroll={(e) => onScroll(e)}>
            <br />
            <br />
            <div style={{ display: "flex" }} className="up_row-integrations">
                <div className="input_integrations_container">
                    <div className="input_integrations">
                        <InputSearch
                            placeholderLibelle="content"
                            onChange={(e) => research(e.target.value)}
                        />
                    </div>
                </div>
                <div className="add_button_container">
                    <div>
                        {hasPermission("create_integration") ? (
                            <IconButton
                                onClick={() => onClickAdd()}
                                icon={"fas fa-plus"}
                                className="main-iconButton profil_action main_add-button"
                            />
                        ) : null}
                    </div>
                </div>
            </div>

            <div className="integrations_table_container">
                {Array.isArray(integrations) &&
                    integrations.map((integration) => {
                        let value = `${window.location.protocol}//${window.location.hostname}:8888/mcp/api?key=${integration.api_key}`;
                        return (
                            <IntegrationCodeLine
                                key={generateKey()}
                                integration={integration}
                                text={value}
                                handleDelete={onClickDelete}
                                api_key={integration.api_key}
                            />
                        );
                    })}
            </div>
        </div>
    );
}

export default IntegrationTableMcp;
